import React, { useContext, useState } from 'react'
import { chatbotExceptionNew, chatbotStepData } from '../../../../models/axiosModel';
import { Checkbox, Divider, Grid, Typography } from '@mui/material';
import globalStyles from "../../../../assets/styles/global.module.scss";
import style from "../../../../assets/styles/componentStyles/campaignContactStyles/campaignContactStyle.module.scss"; 
import workflowStyles from "../../../../assets/styles/componentStyles/manychatStyles/workflowFormComponents/workflowForm.module.scss";
import workflowGlobalStyles from '../../../../assets/styles/componentStyles/manychatStyles/workflowFormComponents/workflowGlobal.module.scss';
import styles from "../../../../assets/styles/componentStyles/chatbot.module.scss";
import GlobalButton from '../../../utility/globalButton/button';
import { UserContext, UserContextPayload } from '../../../../context/userContext';
import { WorkflowContext, WorkflowContextPayload } from '../../../../context/workflowContext';
import { FlowBuilderContext, FlowBuilderContextPayload } from '../../../../context/flowBuilderContext';
import agent from '../../../../services/api';
import { useSearchParams } from 'react-router-dom';

interface NodeIsUseInExceptionWarningProps {
    setFlagNodeUseInException: React.Dispatch<React.SetStateAction<boolean>>,
    listOfExceptionNode: any[],  
    chatbotLevelException: chatbotExceptionNew | null,
    selectedNode: string,
} 

const NodeIsUseInExceptionWarning: React.FC<NodeIsUseInExceptionWarningProps> = (props) => {
    
    const { setFlagNodeUseInException, listOfExceptionNode, chatbotLevelException, selectedNode } = props;
    const [flagDeleteAllExceptions, setFlagDeleteAllExceptions] = useState<boolean>(false);
    const { setFlagLoading, handleError } = useContext(UserContext) as UserContextPayload
    const { nodes, updateException, deleteNode, setNodes, getChatbotPostDeploymentTriggerTypeApi, chatbotPostDeploymentTriggerType } = useContext(FlowBuilderContext) as FlowBuilderContextPayload
    const { setCurrentActiveStaticWorkflow } = useContext(WorkflowContext) as WorkflowContextPayload;

    const [searchParams] = useSearchParams();
    const chatbotId = searchParams.get('workflow_id');

    const getChatbotPostDeploymentTriggerTypeApiCall = async () => {
        const res = await getChatbotPostDeploymentTriggerTypeApi(); 
        if(!(res.status)){
            handleError(res);
        } 
        return res?.data || null;
    }

    const handlePostDeploymentTrigger = async (flag_delete: boolean) => {
        setFlagLoading((prev) => ({...prev, flagRoundLoader: true}));
        let triggerType = chatbotPostDeploymentTriggerType;
        if(!chatbotPostDeploymentTriggerType){
            triggerType = await getChatbotPostDeploymentTriggerTypeApiCall();
        } 

        const chatbotException = chatbotLevelException;
        const payload = {
            chatbot_post_deployment_trigger_id: chatbotException?.chatbot_post_deployment_trigger_id || "", 
            chatbot_post_deployment_trigger_type: {
                chatbot_post_deployment_trigger_type_id: triggerType?.find((trigger) => trigger?.chatbot_post_deployment_trigger_type_name?.toLowerCase() == "exception")?.chatbot_post_deployment_trigger_type_id || "", 
            }, 
            chatbot_step: {
                chatbot_step_id: chatbotException?.chatbot_step?.chatbot_step_id || "",
            }, 
            pre_transition_text_message: chatbotException?.pre_transition_text_message || "", 
            flag_deleted: flag_delete,
        }

        const res = await agent.handleChatbotPostDeploymentTrigger.post(payload, chatbotId || "");
        if(!res.status){
            handleError(res);
        }

        setFlagLoading((prev) => ({...prev, flagRoundLoader: false}));
    } 

    const handleProceedBtnClick = async () => {
        setFlagLoading((prev) => ({...prev, flagRoundLoader: true}));

        try {

            let promises: Promise<any>[] = []; 
            if(listOfExceptionNode?.length > 0){ // Remove Step Level Error handling If exist
                const stepLevelExceptionPromise = listOfExceptionNode?.map(async (exceptionNode) => {
                    const step_type_id = nodes?.find(
                        (node: any) => node?.id === exceptionNode?.id
                    )?.chatbot_step_type_id;
    
                    return await updateException(
                        nodes,
                        exceptionNode?.id,
                        step_type_id,
                        true
                    );
                }); 

                promises.push(...stepLevelExceptionPromise);
            }
            if(chatbotLevelException){ // Remove Chatbot Level Error handling If exist
                promises.push(handlePostDeploymentTrigger(true));
            }

            await Promise.all(promises);

            if(listOfExceptionNode?.length > 0){
                setNodes((prev: any) => {
                    return prev?.map((node: any) => {
                        if(listOfExceptionNode?.find((exceptionNode: any) => exceptionNode?.id == node?.id)){
                            return {
                                ...node, 
                                chatbot_step_exception: null,
                            }
                        }
                        return node;
                    })
                })
            } 
            if(chatbotLevelException){
                setCurrentActiveStaticWorkflow((prev: any) => {
                    return {
                        ...prev,
                        chatbot_exception: null,
                    }
                })
            }

            deleteNode(selectedNode);
        } catch (error) {
            console.error("Failed to update exception:", error);
        }

        setFlagLoading((prev) => ({...prev, flagRoundLoader: false}));
    }

    const getDynamicWarningMessages = () => {
        if(chatbotLevelException && !(listOfExceptionNode?.length > 0)){ 
            return {
                warningTitle: "The node you are trying to delete is still referenced in chatbot level error handling.", 
                updateManuallyMessage: "Update the error handling at chatbot level manually."
            }
        } else if(!chatbotLevelException && listOfExceptionNode?.length > 0) { 
            return {
                warningTitle: "The node you are trying to delete is still referenced in error handling by following steps:",
                updateManuallyMessage: "Update the error handling in these nodes manually.",
            }
        } else if(chatbotLevelException && listOfExceptionNode?.length > 0) {
            return {
                warningTitle: "The node you are trying to delete is still referenced in chatbot level error handling and error handling by following steps:", 
                updateManuallyMessage: "Update the error handling at chatbot level and in these nodes manually.",
            }
        } else {
            return {
                warningTitle: "", 
                updateManuallyMessage: "",
            };
        }
    }

    return (
        <>
            <Grid container>
                <Grid item xs={12}>
                    <Grid container className={`${globalStyles.flexColumn} ${globalStyles.justifyCenter}`}>
                        <Grid item className={globalStyles.textCenter}>
                            <Typography className={style.popupTitleTypography}>Validation Error: This Step is referenced in error handling</Typography>
                        </Grid>

                        <Divider className={style.popupTitleDivider} />   

                        <Grid item className={globalStyles.fullwidth}>
                            <Grid container className={style.popupBodyGridContainer} gap={2}>
                                
                                <Grid item xs={12}>
                                    <Typography className={workflowStyles.nodeIsUsedInExceptionTypography}>
                                        {getDynamicWarningMessages()?.warningTitle} 
                                    </Typography>
                                </Grid>

                                {listOfExceptionNode?.length > 0 &&
                                    <Grid item xs={12}>
                                        <Typography className={workflowStyles.nodeIsUsedInExceptionTypography}>
                                            <ul>
                                                {listOfExceptionNode?.map((node) => {
                                                    return (
                                                        <li>
                                                            {node?.chatbot_step_name}
                                                        </li>
                                                    );
                                                })}
                                            </ul>
                                        </Typography>
                                    </Grid> 
                                }
                                
                                <Grid item xs={12}>
                                    <Typography className={workflowStyles.nodeIsUsedInExceptionTypography}>
                                        To continue, you can either: <br />
                                        1. {getDynamicWarningMessages()?.updateManuallyMessage}<br />
                                        2. Select the below option to automatically delete error handling and delete this node.
                                    </Typography>
                                </Grid>
                                
                                <Grid item xs={12}>
                                    <Grid container alignItems={"center"} gap={"12px"}>
                                        <Grid item className={workflowGlobalStyles.checkBoxStyle}>
                                            <Checkbox 
                                                className={styles.checkedIcon} 
                                                disableRipple 
                                                checked={flagDeleteAllExceptions}
                                                onChange={(event) => { setFlagDeleteAllExceptions(event.target.checked)  }} 
                                            />
                                        </Grid>
                                        <Grid item className={styles.checkboxStyle}>Delete all error handling actions from the specified nodes and delete this node</Grid>
                                    </Grid>
                                </Grid> 

                                <Grid item xs={12} marginTop={"20px"}>
                                    <Grid container justifyContent={"center"} gap={"12px"}>
                                        <Grid item>
                                            <GlobalButton
                                                buttonText="Cancel"
                                                className='borderedButtonStyle'
                                                sx={{ width: "130px !important" }} 
                                                onClick={() => setFlagNodeUseInException(false)}
                                            />
                                        </Grid>
                                        <Grid item>
                                            <GlobalButton
                                                buttonText="Proceed"
                                                className='primaryButtonStyle'
                                                sx={{ width: "130px !important" }} 
                                                disabled={!flagDeleteAllExceptions}
                                                onClick={() => handleProceedBtnClick()}
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>

                    </Grid>
                </Grid>
            </Grid>
        </>
    )
}

export default NodeIsUseInExceptionWarning
